<template lang="pug">
 .component-body.full-size
    nav
      ul
        div(
          v-for="item in menu"
          v-if="item.exibir !== false"
        )
          el-tooltip#tooltip(
            effect='dark',
            :content="item.nome",
            :disabled ="(item.nome.length < 26 && windowWidth > 1365)",
            placement="right"
          )
            li.menu-item(
              :class="{'active': $route.meta.routeGroup == item.routeGroup}",
              :id="`menu-side-${item.routeName}`"
              @click.stop="goTo(item.routeName, item.params)"
            )
              .menu-group
                i.menu-icon.fal(:class="item.icon")
                .menu-text(v-if="item.nome.length > 25")
                  span {{ item.nome.slice(0,35) }}...
                .menu-text(v-if="item.nome.length <= 25")
                  span {{ item.nome.slice(0,25) }}

</template>

<script>
import { mapGetters } from 'vuex'

export default {

  data () {
    return {
      windowWidth: 0,
      maxChars: 30
    }
  },

  computed: {
    ...mapGetters({
      menu: 'menu/menu'
    })
  },

  created () {
    this.$nextTick(function () { // eslint-disable-line
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  },

  methods: {
    goTo (name, params) {
      this.$router.push({
        name,
        params: {
          ...params
        }
      })
    },

    getWindowWidth () {
      this.windowWidth = document.documentElement.clientWidth
    }
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
  }

}
</script>

<style lang="scss" scoped>
.component-body {
  width: 150px;
  display: flex;
  position: relative;
  background-color: #f3f7fa;
  min-height: 100vh;
  height: auto !important;

  nav {
    width: 150px;
    color: #606266;
    -webkit-box-shadow: 0px 0px 7px -5px #eaeef1;
    box-shadow: 8px 0px 7px -5px #eaeef1;

    ul {
      padding: 0;
      margin: 0;
    }

    .menu-item {
      padding: 5px;
      height: 90px;
      display: flex;
      align-items: center;
      transition: hover 1s;

      .menu-group {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        i {
          font-size: 20px;
        }
      }
    }

    .menu-item:hover {
      cursor: pointer;
      background-color: rgba(0, 159, 97, 0.1);
      -webkit-transition: background-color 0.2s ease-out;
      -moz-transition: background-color 0.2s ease-out;
      -o-transition: background-color 0.2s ease-out;
      transition: background-color 0.2s ease-out;
    }
  }
}

.active {
  color: #009f61;
  background: linear-gradient(-45deg, #009f61 0%, #009f61 7%, white 0%);
}

.menu-text {
  margin-top: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
}

@media (max-width: 780px) {
  .component-body nav {
    width: 40px !important;
  }

  .component-body {
    width: 40px !important;
  }
}

@media (max-width: 1365px) {
  .component-body {
    width: 60px;
    nav {
      .menu-item {
        height: 50px;
      }
    }
  }
  .menu-icon {
    font-size: 20px;
  }
  .menu-text {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue